export const formatBanendFlag = (banendFlag: string | null) => {
  if (banendFlag && banendFlag === 'EM00') {
    return banendFlag + '-可再转让'
  } else if (banendFlag && banendFlag === 'EM01') {
    return banendFlag + '-不得转让'
  } else {
    return ''
  }
}

export const formatSplitFlag = (splitFlag: string | null) => {
  if (splitFlag && (splitFlag === '0' || splitFlag === '2')) {
    return '不可拆包'
  } else if (splitFlag && splitFlag === '1') {
    return '可拆包'
  } else {
    return ''
  }
}

export const formatDraftType = (draftType: string | null) => {
  if (draftType && draftType === 'AC01') {
    return draftType + '-银票/财票'
  } else if (draftType && draftType === 'AC02') {
    return draftType + '-商票'
  } else {
    return ''
  }
}

export const formatRequestEntrustPay = (requestEntrustPay: string | null) => {
  if (requestEntrustPay && requestEntrustPay === 'CC00') {
    return requestEntrustPay + '-含委托/承诺兑付'
  } else if (requestEntrustPay && requestEntrustPay === 'CC01') {
    return requestEntrustPay + '-不含委托/不承诺兑付'
  } else {
    return ''
  }
}

export const formatSignupMark = (signupMark: string | null) => {
  if (signupMark && signupMark === 'SU00') {
    return signupMark + '-同意'
  } else if (signupMark && signupMark === 'SU01') {
    return signupMark + '-拒绝'
  } else {
    return ''
  }
}

export const formatBehaveType = (behaveType: string | null) => {
  // ET01-承兑 ET02-保证 ET03-质押 ET04-质押解除 ET05-转让背书 ET06-止付/冻结 ET07-解除止付/冻结 ET09-提示付款 ET10-追索
  if (behaveType) {
    switch (behaveType) {
      case 'ET01':
        return behaveType + '-承兑'
      case 'ET02':
        return behaveType + '-保证'
      case 'ET03':
        return behaveType + '-质押'
      case 'ET04':
        return behaveType + '-质押解除'
      case 'ET05':
        return behaveType + '-转让背书'
      case 'ET06':
        return behaveType + '-止付/冻结'
      case 'ET07':
        return behaveType + '-解除止付/冻结'
      case 'ET09':
        return behaveType + '-提示付款'
      case 'ET10':
        return behaveType + '-追索'
      // ET12-转托管 ET13-买断式回购 ET14-回购式贴现 ET15-回购式贴现赎回 ET17-买断式回购赎回 ET18-权属初始登记 ET19-质押式回购 ET20-质押式回购赎回
      case 'ET12':
        return behaveType + '-转托管'
      case 'ET13':
        return behaveType + '-买断式回购'
      case 'ET14':
        return behaveType + '-回购式贴现'
      case 'ET15':
        return behaveType + '-回购式贴现赎回'
      case 'ET17':
        return behaveType + '-买断式回购赎回'
      case 'ET18':
        return behaveType + '-权属初始登记'
      case 'ET19':
        return behaveType + '-质押式回购'
      case 'ET20':
        return behaveType + '-质押式回购赎回'
      // ET21-再贴现质押式回购 ET22-再贴现质押式回购赎回
      case 'ET21':
        return behaveType + '-再贴现质押式回购'
      case 'ET22':
        return behaveType + '-再贴现质押式回购赎回'
      default:
        return ''
    }
  } else {
    return ''
  }
}
